"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var GridResponse =
/** @class */
function () {
  function GridResponse(counter) {
    if (counter === void 0) {
      counter = 0;
    }

    this.CurrentPage = 0;
    this.TotalPages = 1;
    this.Counter = isNaN(counter) ? 0 : counter;
  }

  return GridResponse;
}();

exports["default"] = GridResponse;